import { render, staticRenderFns } from "./FormTemporalAssignment.vue?vue&type=template&id=00ba8c60&lang=pug"
import script from "./FormTemporalAssignment.vue?vue&type=script&lang=js"
export * from "./FormTemporalAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ba8c60')) {
      api.createRecord('00ba8c60', component.options)
    } else {
      api.reload('00ba8c60', component.options)
    }
    module.hot.accept("./FormTemporalAssignment.vue?vue&type=template&id=00ba8c60&lang=pug", function () {
      api.rerender('00ba8c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormTemporalAssignment.vue"
export default component.exports